function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M40.8,4l14.6,14.6L50,31.3L25.6,55.8L4.2,34.4L28.8,9.9L40.8,4 M41.4,0.4L27,7.4l-27,27L25.6,60l27-27l6.3-15.1 L41.4,0.4L41.4,0.4z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 19.3,
  y: 29.3,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 30.5726 -12.305)",
  width: 21.7,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 14.1,
  y: 34.4,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 32.7181 -7.1255)",
  width: 21.7,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 8.9,
  y: 39.6,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 34.8636 -1.9459)",
  width: 21.7,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 49.8,
  y: -3.6,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 21.1875 -33.7014)",
  width: 3,
  height: 24.7
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M39.4,26.7c-1.6,0-3.1-0.6-4.3-1.8c-1.1-1.1-1.8-2.7-1.8-4.3s0.6-3.1,1.8-4.3c1.1-1.1,2.7-1.8,4.3-1.8s3.1,0.6,4.3,1.8 c1.1,1.1,1.8,2.7,1.8,4.3c0,1.6-0.6,3.1-1.8,4.3l0,0l0,0c0,0,0,0,0,0C42.5,26,41,26.7,39.4,26.7z M39.4,17.6 c-0.8,0-1.6,0.3-2.1,0.9c-0.6,0.6-0.9,1.3-0.9,2.1c0,0.8,0.3,1.6,0.9,2.1c1.1,1.1,3.1,1.1,4.3,0v0c0.6-0.6,0.9-1.3,0.9-2.1 c0-0.8-0.3-1.6-0.9-2.1C40.9,17.9,40.2,17.6,39.4,17.6z"
})))));

var SvgPriceTag = function SvgPriceTag(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/price-tag.91fcb4ec.svg";
export { SvgPriceTag as ReactComponent };